import React from "react";
import moment from "moment-timezone";
import { map, isEmpty, orderBy } from 'lodash';
import { formatToCurrency } from "../../../../Tools/formatToCurrency";

// mapping of lead stage
const leadStage = {
  new: 'New',
  contacted: 'Contacted',
  interested: 'Interested',
  customer: 'Customer'
};

// mapping of out reach
const outreach = {
  website: 'Website',
  call_center: 'Call Center',
  franchisee: 'Franchisee',

};

// const LAST_CLEANED = { less_than_2_weeks: 'Less than 2 weeks ago', '1-2_months': '2 to 6 weeks', '2_months_or_more': 'More than 6 weeks ago' }

class DataTable {
  // format phone number
  formatPhoneNumber = (phone) => {
    phone = phone?.replace(/\D/g, '');
    return phone?.substr(0, 3) + ' ' + phone?.substr(3, 3) + ' ' + phone?.substr(6);
  }

  // convert date time from utc to local time
  UTCToLocal = (date) => {
    let stillUtc = moment.utc(date).toDate();
    return moment(stillUtc).local();
  }

  // convert date time from local to utc
  localToUTC = (date) => {
    return moment.utc(date)
  }

  // customer columns
  customerColumns = (franchiseList, search_value) => {
    return ([
      {
        title: 'Acc Number',
        dataIndex: 'acc_number',
        key: 'acc_number',
        sorter: false,
        render: (text, record) => <span>{record?.account_number}</span>
      },
      {
        title: 'Customer Name',
        dataIndex: 'customer_name',
        key: 'customer_name',
        sorter: false,
        render: (text, record) => {
          const isInclude = (search_value && (record?.first_name?.toLowerCase()?.includes(search_value?.toLowerCase()) || record?.last_name?.toLowerCase().includes(search_value?.toLowerCase()))) ? true : false;
          const name = record?.first_name ? `${record?.first_name} ${record?.last_name}` : '';
          if (search_value && isInclude) {
            const pattern = new RegExp(search_value, "gi");
            const new_text = name.replace(pattern, "<u>$&</u>");
            return <span className="ellipse" id={`customerName${record.uuid}`} dangerouslySetInnerHTML={{ __html: `<b>${new_text}</b>` }}></span>
          } else {
            return <span className="ellipse" id={`customerName${record.uuid}`} dangerouslySetInnerHTML={{ __html: `<b>${name}</b>` }}></span>
          }
        }
      },
      {
        title: 'Address (Billing)',
        dataIndex: 'billing_address',
        key: 'billing_address',
        sorter: false,
        render: (text, record) => {
          const address = record?.billing_address.length > 0 ? `${record?.billing_address?.[0]?.address || ''}, ${record?.billing_address?.[0]?.city || ''}, ${record?.billing_address?.[0]?.state || ''} ${record?.billing_address?.[0]?.zip_code || ''}` : '';
          const isInclude = (search_value && address?.toLowerCase()?.includes(search_value?.toLowerCase())) ? true : false;
          if (search_value && isInclude) {
            const pattern = new RegExp(search_value, "gi");
            const new_text = address.replace(pattern, "<u>$&</u>");
            return <span className="ellipse" id={`customerAddress${record.uuid}`} dangerouslySetInnerHTML={{ __html: `${new_text}` }}></span>
          } else {
            return <span className="ellipse" id={`customerAddress${record.uuid}`} dangerouslySetInnerHTML={{ __html: `${address}` }}></span>
          }
        }
      },
      {
        title: 'Phone Number',
        dataIndex: 'phone_numbers__phone',
        key: 'phone_numbers__phone',
        sorter: true,
        className: 'tphnum',
        render: (text, record) => {
          let phone_numbers = '';
          !isEmpty(record?.phone_numbers) && map(record?.phone_numbers, (item) => {
            phone_numbers = item?.primary && item?.phone;
          })

          return <span>{!isEmpty(record?.phone_numbers) ? phone_numbers ? `+1 ${this.formatPhoneNumber(phone_numbers)}` : `+1 ${this.formatPhoneNumber(record?.phone_numbers?.[0]?.phone)}` : ''}</span>
        }
      },
      {
        title: 'Email Address',
        dataIndex: 'email',
        key: 'email',
        sorter: true,
        render: (text, record) => {
          if (!record?.is_dummy_email && !record.email.includes('doody.com')) {
            const isInclude = (search_value && record?.email?.toLowerCase()?.includes(search_value?.toLowerCase())) ? true : false;
            if (search_value && isInclude) {
              const pattern = new RegExp(search_value, "gi");
              const new_text = record?.email.replace(pattern, "<u>$&</u>");
              return <span className="ellipse" id={`customerEmail${record.uuid}`} dangerouslySetInnerHTML={{ __html: `${decodeURIComponent(new_text)}` }}></span>
            } else {
              return <span className="ellipse" id={`customerEmail${record.uuid}`} dangerouslySetInnerHTML={{ __html: `${record?.email}` }}></span>
            }
          } else {
            return '';
          }
        }
      },
      {
        title: 'Franchise',
        dataIndex: 'franchise',
        key: 'franchise',
        sorter: false,
        filters: franchiseList,
        className: 'lfbdr filterico',
        filterIcon: <i className="las la-filter ml-10" />,
        render: (text, record) => !isEmpty(record?.field_office) ?
          <span>{`${record?.field_office?.name}`}</span> : ''
      },
      {
        title: 'Joined',
        dataIndex: 'joined',
        key: 'joined',
        sorter: false,
        className: 'tdate',
        render: (text, record) => {
          const local_time = this.UTCToLocal(record?.created_at)
          return <span>{local_time.fromNow(true)}</span>
        }
      },
      {
        title: 'Last Service',
        dataIndex: 'last_service',
        key: 'last_service',
        sorter: false,
        className: 'tdate',
        render: (text) => <span>{(text && !isNaN(new Date(text).getTime())) ? this.UTCToLocal(text).format('MMM DD, YYYY') : ''}</span>
      },
      {
        title: 'Outstanding',
        dataIndex: 'outstanding',
        key: 'outstanding',
        sorter: false,
        className: 'tdate',
        render: (text, record) => <span><b>{`$${formatToCurrency(record?.customer_open_invoice_balance)}`}</b></span>
      },
      {
        title: 'Satisfaction',
        dataIndex: 'satisfaction',
        key: 'satisfaction',
        sorter: false,
        className: 'tdate',
        render: (text, record) => <span>{record?.customer_satisfaction_score ? `${record?.customer_satisfaction_score}%` : ''}</span>
      },
      {
        title: 'Next follow up',
        dataIndex: 'next_follow_up',
        key: 'next_follow_up',
        sorter: true,
        className: 'tdate',
        render: (text) => <span>{text ? this.UTCToLocal(text).format('MMM DD, YYYY') : ''}</span>
      },
      {
        title: 'Status',
        dataIndex: 'is_active',
        key: 'is_active',
        sorter: false,
        className: 'tdate',
        render: (text, record) => <span>{record?.status === "pending" ? <b className="info">Pending</b> : (record?.is_active ? <b className="success">Active</b> : <b className="danger">Inactive</b>)}</span>
      }
    ]);
  }

  // leads columns
  leadColumns = (search_value) => {
    return ([
      {
        title: 'Acc Number',
        dataIndex: 'acc_number',
        key: 'acc_number',
        sorter: false,
        render: (text, record) => <span>{record?.account_number}</span>
      },
      {
        title: 'Customer Name',
        dataIndex: 'customer_name',
        key: 'customer_name',
        sorter: false,
        render: (text, record) => {
          const isInclude = (search_value && (record?.first_name?.toLowerCase()?.includes(encodeURIComponent(search_value)?.toLowerCase()) || record?.last_name?.toLowerCase().includes(encodeURIComponent(search_value)?.toLowerCase())));
          return <span className="ellipse" style={{ textDecoration: isInclude ? "underline" : "" }}><b>{record?.first_name ? `${record?.first_name} ${record?.last_name}` : ''}</b></span>
        }
      },
      {
        title: 'Address (Service)',
        dataIndex: 'address',
        key: 'address',
        sorter: false,
        render: (text, record) => <span className="ellipse">{
          record?.address?.[0]?.address ? 
            `${record?.address?.[0]?.address || ''}, ${record?.address?.[0]?.city || ''}, ${record?.address?.[0]?.state || ''} ${record?.address?.[0]?.zip_code || ''}`
            : ""
        }</span>
      },
      {
        title: 'Phone Number',
        dataIndex: 'phone_numbers__phone',
        key: 'phone_numbers__phone',
        sorter: true,
        render: (text, record) => {
          let phone_numbers = '';
          !isEmpty(record?.phone_numbers) && map(record?.phone_numbers, (item) => {
            phone_numbers = item?.primary && item?.phone;
          })

          return <span>{!isEmpty(record?.phone_numbers) ? phone_numbers ? `+1 ${this.formatPhoneNumber(phone_numbers)}` : `+1 ${this.formatPhoneNumber(record?.phone_numbers?.[0]?.phone)}` : ''}</span>
        }
      },
      {
        title: 'Email Address',
        dataIndex: 'email',
        key: 'email',
        sorter: true,
        render: (text, record) => {
          if (!record?.is_dummy_email && !record.email.includes('doody.com')) {
            const isInclude = (search_value && record?.email?.toLowerCase()?.includes(encodeURIComponent(search_value)?.toLowerCase()));
            return <span className="ellipse" style={{ textDecoration: isInclude ? "underline" : "" }}>{record?.email}</span>
          } else {
            return ''
          }          
        }
      },
      {
        title: 'Lead Stage',
        dataIndex: 'lead_stage',
        key: 'lead_stage',
        sorter: false,
        className: 'lfbdr tprofile filterico',
        render: (text, record) => <span>{record?.is_active ? record?.lead_stage ? `${leadStage[record?.lead_stage]}` : '' : 'Deactivated'}</span>
      },
      {
        title: 'Outreach',
        dataIndex: 'outreach',
        key: 'outreach',
        sorter: false,
        className: 'tdate',
        render: (text, record) => <span>{record?.outreach ? `${outreach[record?.outreach]}` : ''}</span>
      },
      {
        title: 'Lead Creation date',
        dataIndex: 'created_at',
        key: 'created_at',
        sorter: true,
        className: 'tdate',
        render: (text, record) => {
          const local_time = this.UTCToLocal(record?.created_at)
          return <span>{record?.created_at ? local_time.format('MMM DD, YYYY') : ''}</span>
        }
      },
      {
        title: 'Last Contacted',
        dataIndex: 'last_contacted',
        key: 'last_contacted',
        sorter: false,
        className: 'tdate',
        render: (text, record) => {
          let contact_log = record?.lead_status_logs?.filter(x => x.stage === "contacted")
          contact_log = orderBy(contact_log, 'created_at', 'desc')
          const local_time = this.UTCToLocal(contact_log[0]?.created_at)
          return <span>{(contact_log[0] && contact_log[0].created_at) ? local_time.format('MMM DD, YYYY') : ''}</span>
        }
      },
      {
        title: 'Next Scheduled Contact',
        dataIndex: 'next_scheduled_contact',
        key: 'next_scheduled_contact',
        sorter: true,
        className: 'tdate',
        render: (text, record) => {
          return <span>{record?.next_scheduled_contact ? this.UTCToLocal(record?.next_scheduled_contact).format('MMM DD, YYYY') : ''}</span>
        }
      },
    ]);
  }

  leadCallHistoryColumns = () => {
    return ([
      {
        title: 'Date/Time',
        dataIndex: 'date_time',
        key: 'date_time',
        className: 'tdate',
        sorter: false,
        render: (text, record) => <span>{record?.next_callback ? moment(record?.next_callback).format('MM/DD/YYYY') : ''}</span>
      },
      {
        title: 'Purpose',
        dataIndex: 'purpose',
        key: 'purpose',
        sorter: false,
        className: 'tname',
        render: (text, record) => <span>{record?.reason ? record?.reason : ''}</span>
      },
      {
        title: 'Notes',
        dataIndex: 'notes',
        key: 'notes',
        sorter: false,
        className: 'tadd',
        render: (text, record) => <span>{record?.notes ? record?.notes : ''}</span>
      },
      {
        title: 'Contact Method',
        dataIndex: 'contact_method',
        key: 'contact_method',
        sorter: false,
        className: 'tadd',
        render: (text, record) => <span>{record?.contact_method ? record?.contact_method : ''}</span>
      }
    ])
  }
}

export default new DataTable();
